import { axios } from './axios';

import { OrderProduct } from '@/pages/types';

const productItemsCache = new Map<string, Promise<any>>();

export const getProductItems = (
  productCode: OrderProduct['code'],
  country: string
): Promise<any> => {
  const cacheKey = `${productCode}:${country}`;

  if (!productItemsCache.has(cacheKey)) {
    const request = axios.get(`/products/${productCode}?country=${country}`).catch((error) => {
      productItemsCache.delete(cacheKey);
      throw error;
    });
    productItemsCache.set(cacheKey, request);
  }

  return productItemsCache.get(cacheKey) as Promise<any>;
};
